import React, { useState } from 'react';
import { Button, Modal } from "react-bootstrap";
import filtersearch from "../assets/images/icon/filter-search.png";
import Input from 'components/Input';
import Checkbox from 'components/Checkbox';


function AddTimekeepingSettingModal({ show, setShow }) {
    // const [show, setShow] = useState(false);

    return (
        <div className='add-timekeeping-setting-modal'>
            <Modal className='add-timekeeping-setting-modal' show={show} onHide={() => setShow(false)} centered>
                <div className="modal-header border-0 d-flex justify-content-between align-items-center">
                    <h5 className="main-title mb-0">Add Timekeeping Settings</h5>
                    <button type="button" className="close bg-transparent border-0" data-dismiss="modal" aria-label="Close" onClick={() => setShow(false)}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <Modal.Body>
                    <form>
                        <div className="search-input position-relative">
                            <label>Timekeeping Information</label>
                            {/* <input type='text' className='input-search w-100' placeholder='Default Timezone'/> */}
                            <Input
                                fullWidth
                                variant='flat'
                                placeholder='Default Timezone'
                            />
                            <img className="search-icon end-0 mt-2 me-2 position-absolute" src={filtersearch} alt="filtersearch" />
                        </div>
                        <div>
                            <h2 className='sub-title my-3'>Overtime Hours Start</h2>
                        </div>
                        <div className="row mt-2 mb-4 border-bottom">
                            <div className="col-lg-6">
                                <div>
                                    <label>Daily Overtime Hours Start*</label>
                                    <Input
                                        type='date'
                                        fullWidth
                                        variant='flat'
                                        placeholder='dd/mm/yyyy'
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div>
                                    <label>Weekly Overtime Hours Start*</label>
                                    {/* <input type='time' className='input-search w-100' placeholder='00:00'/> */}
                                    <Input
                                        type='time'
                                        fullWidth
                                        variant='flat'
                                        placeholder='00:00'
                                    />
                                </div>
                            </div>
                            <div>
                                <h2 className='sub-title my-4'>Timekeeping Options</h2>
                            </div>
                        </div>
                    </form>
                    <div>
                        <div className="form-check">
                            <Checkbox
                                size="small"
                                label="Enable Paystubs Portal Clock-in"
                            />
                        </div>
                        <div className="form-check mt-3">
                            <Checkbox
                                size="small"
                                label="Enable Paid Meal Breaks"
                            />
                        </div>
                        <div className="form-check mt-3">
                            <Checkbox
                                size="small"
                                label=" Enable Paid Rest Breaks"
                            />
                        </div>
                        <div className="form-check mt-3">
                            <Checkbox
                                size="small"
                                label="Force Employee Code"
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className='border-0 justify-content-start mb-5'>
                    <Button className='button-orange'>
                        Add Settings
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}


export default AddTimekeepingSettingModal;
